import { ComponentProps, createContext, createRef, MutableRefObject, ReactElement } from 'react';

export const openModalOnAllWindows = createRef<HTMLDivElement>();

/**
 * @param showOnAllWindows If true this modal will show on all windows opened from main window including main window.
 * @param
 */
export interface ShowModalProps {
  showOnAllWindows?: boolean;
  polledCloseCondition?: () => boolean;
}

// eslint-disable-next-line
export type ComponentType = (props: any) => ReactElement;

/**
 * Promise extended to add the ability to externally resolve dialog.
 */
export interface PromiseWithResolve<RT> extends Promise<RT> {
  resolve: (value: RT) => void;
}

/**
 * Properties passed to the modal component to allow resolving.
 */
export interface LuiModalAsyncCallback<R> {
  resolve: (result: R | undefined) => void;
  close: () => void;
}

export interface LuiModalAsyncContextType {
  showModal: <
    OR extends HTMLElement | null,
    // eslint-disable-next-line
    PROPS extends LuiModalAsyncCallback<any>,
    CT extends (props: PROPS) => ReactElement,
    RT = Parameters<ComponentProps<CT>['resolve']>[0],
  >(
    ownerRef: MutableRefObject<OR>,
    component: CT,
    args: Omit<ComponentProps<CT>, 'resolve' | 'close'>,
    showModalProps?: ShowModalProps,
  ) => PromiseWithResolve<RT>;
}

export const LuiModalAsyncContext = createContext<LuiModalAsyncContextType>({
  // eslint-disable-next-line @typescript-eslint/require-await
  showModal: (async () => {
    console.error('Missing LuiModalAsyncContext Provider');
  }) as unknown as LuiModalAsyncContextType['showModal'],
});
